<template>
  <v-container class="input-text-size">
    <v-row>
      <v-col cols="4">
        <ClarionDateControl
          label="Remit Warrant Date"
          :isRequired="false"
          :isToggle="false"
          v-model="remitWarrantDate"
        />
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col>
        <v-btn
          color="primary"
          small
          rounded
          :disabled="!remitWarrantDate"
          @click="handleImportWarrants"
        >
          Import Warrants
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="openReplaceDialog" max-width="420" class="input-text-size">
      <v-card>
        <v-card-title class="input-text-size">Replace Records?</v-card-title>
        <v-card-text class="input-text-size">
          <v-container>
            <v-row dense hide-details>
              <span>Warrants for the date {{ remitWarrantDate }} have already been created.</span>
              <span>Do you wish to replace those warrant records?</span>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="input-text-size">
          <v-btn color="primary" small @click="confirmImportWarrants">Continue</v-btn>
          <v-btn small @click="openReplaceDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { toIsoDate } from '../../../util/shared/tmc-global';

const BASE_CRUD_KEY = 'warRemitWarrantsCrudKey';

export default {
  name: 'WarRemitWarrants',
  components: { ClarionDateControl },
  data() {
    return {
      remitWarrantDate: null,
      openReplaceDialog: false,
    };
  },
  methods: {
    ...mapActions(['flashWarn']),
    ...mapActions('apportionment/apportionmentRemitWarrants', [
      'loadApportionmentRemitWarrantsRecords',
      'buildActualWarrantsRecord',
    ]),
    async handleImportWarrants() {
      if (!this.remitWarrantDate) {
        this.flashWarn('Please select Remit Warrant Date!');
        return;
      }
      const isoDate = toIsoDate(this.remitWarrantDate);
      const criteria = { remitWarrantDate: isoDate };
      const records = await this.loadApportionmentRemitWarrantsRecords({
        criteria,
        baseCrudKey: BASE_CRUD_KEY,
      });
      const alreadyCreated = (records || []).filter((r) => r.warrantsCreated === true);
      if (alreadyCreated.length > 0) {
        this.openReplaceDialog = true;
      } else {
        await this.doImportWarrants(isoDate);
      }
    },
    async confirmImportWarrants() {
      this.openReplaceDialog = false;
      const isoDate = toIsoDate(this.remitWarrantDate);
      await this.doImportWarrants(isoDate);
    },
    async doImportWarrants(isoDate) {
      const criteria = {
        remitWarrantDate: isoDate,
        paidDate: isoDate,
      };
      await this.buildActualWarrantsRecord({ criteria });
    },
  },
};
</script>
